import React from "react";
import { View, StyleSheet } from "react-native";
import NtSectionDescription from "./NtSectionDescription";
import NtText from "../../../components/NtText";

function NtSectionBullet({ containerStyle, style, ...otherProps }) {
  return (
    <View style={[styles.container, containerStyle]}>
      <View
        style={{
          backgroundColor: "white",
          height: 8,
          width: 8,
          borderRadius: 15,
          marginTop: 5,
          marginRight: 10,
        }}
      />

      <NtText
        style={[
          { fontSize: 16, lineHeight: 22, color: "white", fontWeight: "400" },
          style,
        ]}
        {...otherProps}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flexDirection: "row" },
});

export default NtSectionBullet;
